import React, { useState, useEffect, useRef } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { RadioButton } from 'primereact/radiobutton';
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import './TitreCulture.scss';

import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import { FileService } from "../../../service/FileService";
import { ExerciceService } from "../../../service/ExerciceService";
import { useParams } from "react-router-dom";
import { FieldBuilder } from "../fields/FieldBuilder";
import { BudgetService } from "../../../service/BudgetService";
import { AgentService } from "../../../service/AgentService";

export const TitreCultureNotice = ({onConfirm}) => {
  const { mode } = useParams();
  const [usager, setUsager] = useState(false);
  const [adresse, setAdresse] = useState(false);
  const [commande, setCommande] = useState(true);
  const [editCommande, setEditCommande] = useState(true);
  const [policyOne, setPolicyOne] = useState(false);
  const [policyTwo, setPolicyTwo] = useState(false);
  const [step, setStep] = useState(0);
  const [activeIndex, setActiveIndex] = useState([]);
  const [displayBasic, setDisplayBasic] = useState(false);
  const [showFileUploadError, setShowFileUploadError] = useState(false);
  const [showDemandeError, setShowDemandeError] = useState(false);
  const [maCommande, setMaCommande] = useState(true);
  const [justificatifPresence, setJustificatifPresence] = useState(null);
  const [hideJustificatif, setHideJustficatif] = useState(false);
  const fileUploadRef = useRef(null);
  const toast = useRef(null);
  
  const [totalSize, setTotalSize] = useState(0);
  const [disabled, setDisabled] = useState(false);
  const [codeError, setCodeError] = useState(false);
  const [formatCheque, setFormatCheque] = useState();
  const [valeurCommande, setValeurCommande] = useState();

  const [dodEnCours, setDodEnCours] = useState(false);


  const errors = {
          dod: 1,
          statut: 2,
          qf: 2,
          iban: 3,
          pac: 4,
          exercice:5,
          droits:6,
          siDossierValide:7,
          parametrage:8,
          demandeEnCours:9,
          budgetAtteint:10
        };
  const [displayError, setDisplayError] = useState([]);
  let fraisEnvoi;
  let createMode = "create";
  let editMode = "edit";
  let mimeTypes = ["application/pdf", "image/jpg", "image/jpeg", "image/png"];

  const text =<div><p>Politique de protection des données à caractère personnel</p>
          <p>J'ai bien noté que les données à caractère personnel renseignées dans ce formulaire seront recueillies et traitées par le C.G.O.S pour la gestion des demandes d'actions et de prestations.</p>
          <p>Elles pourront également être transmises, si nécessaire pour l'exécution des demandes d'actions et de prestations et pour le respect par le C.G.O.S de ses obligations légales et réglementaires, à des tiers fournisseurs des actions et prestations, sous-traitants du C.G.O.S notamment pour la gestion informatique et financière, en cas d'obligation légale aux autorités publiques, commissaires aux comptes, avocats, experts-comptables.</p>
          <p>Si certains de ces destinataires devaient se situer en dehors de l'Union Européenne, le C.G.O.S concevra des garanties spécifiques pour assurer la protection de vos données.</p>
          <p>Les informations collectées sont conservées tout au long de votre adhésion, puis à l'expiration de celle-ci pendant le délai de prescription.</p>
          <p>Conformément au Règlement (UE) 2016/679 du Parlement européen et du Conseil sur les données (ci-après « RGPD ») et à la loi n° 78/17 du 6 janvier 1978 modifiée, relative à l'informatique, aux fichiers et aux libertés, je dispose d'un droit d'accès, de rectification, d'effacement, d'opposition et de portabilité de l'ensemble des données me concernant collectées par le C.G.O.S, en tant que responsable de traitement.</p>
          <p>Pour exercer ce droit ou pour toute réclamation, je peux adresser un courrier au C.G.O.S à l'attention du Délégué à la Protection des Données : 101 rue de Tolbiac, 75654 PARIS CEDEX 13, ou un mail à l'adresse : dpd@cgos.asso.fr, en joignant à mon envoi par voie postale ou par mail une copie d'un titre d'identité.</p></div>


  const basicDialogFooter = (
    <Button
      type="button"
      label="RETOUR ESPACE AGENT"
      onClick={(e) => logoutRemoveData(e)}
      className="btn_submit_modal"
    />
  );

  const chequeCultureService = new ChequeCultureService();
  const fileService = new FileService();
  const linkService = new LinkProviderService();
  const exerciceService = new ExerciceService();
  const budgetService = new BudgetService();
  const agentService = new AgentService();

  useEffect(() => {
    const fetchExercice = async () => {
      try {
        exerciceService.getExerciceEnCours();
      } catch (error) {
        console.error(error);
      } finally {
        fetchData();
        initActiveIndex();
      }
    };

    fetchExercice();
  }, []);



  const isDatePast = (dateString) => {
      const [year, month,day ] = dateString.split("-").map(Number);
      const inputDate = new Date(year, month - 1, day);

      const currentDate = new Date();

      inputDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      if (inputDate < currentDate) {
          return true;
      }
      return false;
  }

  const fetchData = async () => {
    chequeCultureService.getUsagerInfo().then(
      (res) => {
        loadFormData(res.data);        
          isDemandeEnCours(res.data.numCgos,"3710",localStorage.getItem('exerciceEnCours'));   
      },
      [usager]
   ).catch((err) => {
          setDisplayError(prevState => [...prevState, errors.statut]);
   });

  };


  const loadFormData = (loggedUsager) => {
    setUsager(loggedUsager);
    setAdresse(loggedUsager.adresse);
    if (loggedUsager != null && loggedUsager != undefined) {
      getParamDeleg(loggedUsager.codeDelegation);
      getJustificatifRequis();
      checkFicheAgent(loggedUsager);
    }else{
        setDisplayError(prevState => [...prevState, errors.droits]);
    }

  };

  const checkFicheAgent = (loggedUsager) => {
      agentService.getFicheAgent(loggedUsager.numCgos, localStorage.getItem('exerciceEnCours')).then((res) => {
        if((!loggedUsager.droits.prestationSansCr || isDatePast(loggedUsager.droits.dateExpirationDroits) || res.data.siNoFiche) && !res.data.siDodEncours) {
           setDisplayError(prevState => [...prevState, errors.exercice])
        }
        setDodEnCours(res.data.siDodEncours);

      });
  };

  const  textAdressezVous="Pour en savoir plus ou si vous pensez qu'il y a une erreur, adressez-vous à votre ";
  const justificatifsCategories = [
    { "key": "106", "value": "Bulletin de paie ou attestation de travail délivée par mon établissement" ,"description":"Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%."}
  ];

  const editJustificatifMsg = 'Votre justificatif n’était pas conforme: joindre une copie de votre dernier bulletin de paie ou à défaut une attestation de travail délivrée par votre établissement.'

  const showError = () => {
    toast.current.show({
      severity: "error",
      summary: "ERREUR",
      detail:
        "Le justificatif à joindre est manquant. Merci d’en télécharger un",
      life: 5000,
    });
  };

  const showErrorMimeType = () => {
    toast.current.show({
      severity: "error",
      summary: "ERREUR",
      detail:
        "Le justificatif sélectionné ne correspond pas à l’un des formats de fichier acceptés. Merci d’en sélectionner un compatible.",
      life: 5000,
    });
  };

  useEffect(() => {
    setActiveIndex(prevState => [...prevState, step]);
  },[step]);

  const initActiveIndex = () => {
    if(createMode === mode) setActiveIndex([step]);
    if(editMode === mode) setActiveIndex([0,1,2,3,4,5]);
  };

  const nextStep = (e, increment) => {
    e.target.disabled = true;
    e.target.classList.add("disabled");
    e.target.style.pointerEvents = "none";
    e.target.style.display = "none";
    setStep(step + increment);
    onConfirm(false);
  };

  const showInfo = (msg) => {
    toast.current.show({
      severity: "info",
      summary: "Succés",
      detail: msg + " envoyée avec succés. ",
      life: 5000,
    });
  };
  

  const getParamDeleg = async (codeDelegation) => {
    chequeCultureService
      .getParamChequeCulture(codeDelegation)
      .then((res) => {
        if(null === res || res.data.length===0){
            setDisplayError(prevState => [...prevState, errors.parametrage])
        }
        fraisEnvoi = res.data[0].fraisAffranchissement;
        if (mode == editMode) {
          loadCommandeForm();
        }
        const getProp = (prop) => (obj) => obj[prop];
        const getMontant = getProp("montant");
        const montans = res.data.map(getMontant);
        console.log("montants::" + montans);
        isEnoughBudget(codeDelegation, localStorage.getItem('exerciceEnCours'), (Math.min(...montans))/2);
        setMaCommande(
          res.data.map((param) => (
            <div className="alert alert-success" key={param.montant}>
              <input
                type="radio"
                value={param.montant}
                name="PMC_ID_RADIO"
                onChange={onCommandeChanged}
              />
              <b>
                &nbsp;&nbsp;&nbsp; Commander un chéquier d'une valeur de{" "}
                {param.montant}€{" "}
              </b>
              {res.data.length == 1 && (
                <i>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1 seule commande par
                  an.
                </i>
              )}
              {res.data.length == 2 && (
                <i>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                  {Math.max(...montans) == param.montant
                    ? "1 seule commande par an."
                    : "2 commandes possibles par an. Attention, la deuxième commande peut ne pas être honorée si le budget disponible est atteint."}
                </i>
              )}
            </div>
          ))
        );
      })
      .catch((error) => {
        setDisplayError(prevState => [...prevState, errors.parametrage]);
      });
  };

  const loadCommandeForm = () => {
    chequeCultureService
      .getEditDto()
      .then((res) => {
        setEditCommande(res.data);
        let object = {
          valeurCommande: (res.data.montantTotal - fraisEnvoi) * 2,
          partCgos: res.data.montantTotal - fraisEnvoi,
          frais: fraisEnvoi,
          total: res.data.montantTotal,
        };
        setCommande(object);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getJustificatifRequis = async () => {
    chequeCultureService
      .getJustificatifRequis()
      .then((res) => {
        setHideJustficatif(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const isDemandeEnCours = async (numCgos,codeCas,exercice) => {
      chequeCultureService
        .isDemandeEnCours(numCgos,codeCas)
        .then((res) => {
          if(!res.data){
            setDisplayError(prevState => [...prevState, errors.demandeEnCours]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };

     const isEnoughBudget = async (codeDelegation,exercice,montant) => {
      console.log("montant minimum de la deleg : " + montant );
      budgetService
        .isEnoughBudget(codeDelegation,exercice,montant)
        .then((res) => {
          if(!res.data){
            setDisplayError(prevState => [...prevState, errors.budgetAtteint]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }; 

  

  const onCommandeChanged = (e) => {
    let choosedCommand = e.currentTarget.value;
    let object = {
      valeurCommande: choosedCommand,
      partCgos: choosedCommand / 2,
      frais: fraisEnvoi,
      total: choosedCommand / 2 + fraisEnvoi,
      envoi: true,
    };

    setCommande(object);
  };

  const handleAnnuler = () => {
    chequeCultureService.redirectEaLegacy();
  };
  const onPolicyOneChange = () => {
    setPolicyOne(!policyOne);
  };

  const onPolicyTwoChange = () => {
    setPolicyTwo(!policyTwo);
  };

  const logoutRemoveData = (e) => {
    chequeCultureService.logOut().then((res) => {
      console.log(res);
    });
    handleAnnuler();
  };

  const submitEditedDemande = () => {
    if (justificatifPresence && justificatifPresence.length > 0) {
      setDisabled(true);
      fileService
        .uploadEditedFiles(justificatifPresence, editCommande.recordId)
        .then((res) => {
          if (null != res.data && res.data != undefined) {
            showInfo("Justificatif");
            updateEditedDemande(editCommande.demandeId);
          } else {
            setShowFileUploadError(true);
          }
        })
        .catch((err) => {
          window.location =
            "/#/serviceIndisponible/" + err.response.data.errorId;
        });
    } else {
      showError();
    }
  };

  const submitFormDemande = () => {
    
    const jsonFormSchema = { montant: commande.total, optionDemande: 0 };
    const CommandesArray = [];

    maCommande.forEach((com) => {
      CommandesArray.push(com.key);
    });

    if (commande.valeurCommande == Math.max(...CommandesArray)) {
      jsonFormSchema.optionDemande = 2;
    } else {
      jsonFormSchema.optionDemande = 1;
    }
    const demande = {
      etape: "1",
      origine: "NEA",
      exercice: localStorage.getItem('exerciceEnCours'),
      codeClasseur: "3710",
      demandeStatutReferentiel: { id: 1 },
      demandeDetails: [],
    };

    const demandeDetail = {
      demandeType: {
        codeActionSocial: "3710",
      },
      formJson: JSON.stringify(jsonFormSchema),
      montant: commande.total,
      motif:"frpmage",
      version: "1",
    };

    demande.demandeDetails.push(demandeDetail);

    if (hideJustificatif) {
      if (justificatifPresence && justificatifPresence.length > 0) {
        setDisabled(true);
        fileService
          .uploadMultiFile(justificatifPresence)
          .then((res) => {
            if (null != res.data && res.data != undefined) {
              showInfo("Justificatif");
              saveDemande(demande);
            } else {
              setShowFileUploadError(true);
            }
          })
          .catch((err) => {
            window.location =
              "/#/serviceIndisponible/" + err.response.data.errorId;
          });
      } else {
        showError();
      }
    } else {
      setDisabled(true);
      saveDemande(demande);
    }
  };

  const saveDemande = (demande) => {
    chequeCultureService
      .submitDemandeForm(demande)
      .then((res) => {
        setDisplayBasic(true);
        showInfo("Demande");
      })
      .catch((err) => {
           window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
      });
  };

  const updateEditedDemande = (demandeId) => {
    chequeCultureService
      .submitUpdatedDemande(demandeId)
      .then((res) => {
        setDisplayBasic(true);
        showInfo("Demande");
      })
      .catch((err) => {
        window.location = "/#/serviceIndisponible/" + err.response.data.errorId;
      });
  };
  return (
    <>

                 {displayError.length > 0 && !displayError.includes(errors.dod) && !displayError.includes(errors.demandeEnCours) && !displayError.includes(errors.budgetAtteint)  && (
                   <div className="alert alert-danger" style={{textAlign:"center"  }}>
                       <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif"}}>Vous ne pouvez pas demander cette prestation car <b>le contenu ou le statut actuel de votre dossier C.G.O.S ne le permet pas ou pas encore.</b> <p> Actualisez votre dossier depuis la rubrique
                          <a href={linkService.getRetourEaSaisieDossier()} target="_blank"> Dossier C.G.O.S en ligne</a>. </p><p> {textAdressezVous}<a href={'https://www.cgos.info/01/nous-contacter/'} target="_blank"> contact C.G.O.S</a></p> </span>
                   </div>
                  )}
                 {dodEnCours && (
                          <div className="alert alert-success" style={{textAlign:"center"  }}>
                                 <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif", }}>Votre dossier C.G.O.S { localStorage.getItem('exerciceEnCours') } est en cours de traitement.<b> Votre demande de prestation sera étudiée après l’ouverture de vos droits.</b> <p>Votre quotient familial sera calculé si vous avez joint votre avis d’impôt sur les revenus.</p></span>
                          </div>
                 )}
                 { displayError.includes(errors.demandeEnCours) && <div className="alert alert-danger" style={{textAlign:"center"  }}>
                                                      <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif",}}>Vous ne pouvez pas demander cette prestation pour le moment car
                                                      <b> vous avez déjà une demande de Titres Culture en cours de traitement.</b></span>
                                  </div>}
                  { displayError.includes(errors.budgetAtteint) && <div className="alert alert-danger" style={{textAlign:"center"  }}>
                                      <span style={{ fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif",}}>Le budget annuel alloué à la prestation Titres culture est maintenant épuisé.
                                      <b> L'accès au formulaire de demande est fermé pour cette raison.</b></span>
                  </div>}                 
                 Le Titre culture vous permet d’accéder à tout l’univers de la culture qu’elle soit traditionnelle (livres, spectacles, musées, cinémas…) ou en ligne (streaming, multimédia, jeux vidéo).
                 <br/><br/>
                 Les Titres cultures papier et les E-titres culture sont valables deux ans à compter de la date d’émission.
                
                <br/><br/>
                • Cette action est ouverte à tous.
                <br/>• Elle est versée dans la limite des budgets disponibles.
                <br/>• Elle n'est ni imposable ni assujettie aux cotisations sociales.
                
                <br/><br/>
                Pour en bénéficier, je dois avoir complété et envoyé au préalable mon dossier C.G.O.S pour l'année concernée
                (N), et attendre que mes droits soient ouverts pour l'année concernée (N),
                  
                <br/><br/>
                <div className="help">
                 <span >Depuis le 1er septembre 2025 la marque <b>Glady</b> by Pluxee devient <b>TirGroupé</b> by Pluxee. </span>
                 </div>
                <br/>
                <div class="notice">
                  <b>
                     <font size="3" color="#34495E">
                         E-titres culture

                    </font>
                  </b>
                  <div>
                    <img className="tutorial-image" src="/assets/image/LOGO-TGBYPLUXEE.png"
                         style={{  maxWidth: "105px", marginTop: "20px", marginBottom: "20px"}}/>{" "}
                  </div>

                                  Les E-titres culture sont des titres dématérialisés avec lesquels vous pouvez régler directement en ligne ou en magasin.
                                  <br/><br/>
                                  Le montant de votre commande sera crédité sous 1 à 2 semaines dans votre Espace Pluxee.
                                  Vous recevrez alors un email contenant un lien de connexion et votre identifiant pour y accéder.
                                  <br/><br/>
                                  Comment convertir vos E-titres culture en bons d’achats auprès des enseignes ? 
                                  <br/><br/>
                                  1. Vous choisissez une enseigne parmi les partenaires. 
                                  <a href="https://www.pluxee.fr/enseignes-cadeaux" target="_blank"> Consulter la liste des enseignes. </a>
                                  
                                  <br/>2. Vous saisissez le montant que vous souhaitez dépenser et l’ajoutez à votre panier.
                                  <br/>3. Vous avez maintenant dans votre Espace (Mes achats) un bon d’achat pour l’enseigne et le montant choisis et vous le recevez également par email.
                                  <br/>4. Vous pouvez utiliser ce bon d’achat sur le site de l’enseigne ou dans son magasin.
                                  <br/><br/>

                </div>
                <br/>
                <div class="notice">
                  <b><font size="3" color="#34495E">
                    Titres culture papier
                  </font></b>
                  <div>
                    <img className="tutorial-image" src="/assets/image/LOGO-TGBYPLUXEE.png"
                         style={{ maxWidth: "105px", marginTop: "20px", marginBottom: "20px"}}/>{" "}
                  </div>

                  Un chéquier papier est composé de Titres culture de 10 € acceptés directement pour régler dans les enseignes. 
                  Vous le recevrez à votre adresse postale (1), après le paiement de votre participation au C.G.O.S, sous 4 à 6 semaines (2). 
                  Des frais d’affranchissement vous seront demandés. <a href="https://www.pluxee.fr/enseignes-cadeaux" target="_blank"> Consulter la liste des enseignes. </a>

                  <br/><br/>

                  (1) Les Titres culture à destination de Mayotte seront envoyés à votre établissement. Dès réception, ce
                  dernier vous proposera de les récupérer auprès du contact C.G.O.S de référence.
                  
                  <br/><br/>

                  (2) Le délai de livraison de la métropole vers les départements et régions d'outre-mer peut prendre
                  jusqu'à 2 à 3 semaines supplémentaires.

                  <br/><br/>
                </div>



                {hideJustificatif && (
                  
                    <>
                    <div className="info-wrapper">
                      <span
                          style={{
                          fontSize: "12.0pt",
                          //fontFamily: "Tahoma, sans-serif",
                          color: "rgb(0, 0, 0)",
                          fontWeight: "bold",
                          }}
                      >
                          Documents à préparer avant ma demande
                      </span>
                    </div>

                    <div class="card-justificatif">
                    <div class="card-justificatif-body">
                        <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                        <img src="/assets/image/DOC-1.png" alt="illustration document à préparer " />
                        </div>
                        <div class="card-justificatif-txt-container" style={{width: "85%"}}>
                        <div class="card-justificatif-titre pt-2">
                            <span
                            style={{
                                fontSize: "9.0pt",
                                fontFamily: "Tahoma, sans-serif",
                            }}
                            >
                                Justificatif de présence en établissement
                        
                            </span>
                        </div>
                        <div className="card-justificatif-description">
                          <ul
                            style={{
                              listStyleType: "disc",
                              listStylePosition: "inside",
                              padding: 0,
                              margin: 0,
                              fontSize: "9.0pt",
                              fontFamily: "Tahoma, sans-serif",
                            }}
                          >
                            <li style={{ marginBottom: "4px" }}>
                              Bulletin de paie ou attestation de travail de moins d’un mois.
                            </li>
                            <li>
                              Décision administrative de congés parental à 100%.
                            </li>
                          </ul>
                        </div>

                        </div>
                    </div>
                    </div>

                    <div className="tutorial">
                    <img className="tutorial-image" src="/assets/icon_youtube.png" alt="tutoriel vidéo"/>{" "}
                    <a
                        target="_blank"
                        href="https://www.youtube.com/watch?v=rQzzWn7Yz-o"
                    >
                        <span
                          style={{
                              fontSize: "10.0pt",
                              fontFamily: "Tahoma, sans-serif",
                              color:"#464d4e",
                          }}
                        >
                        # TutorielCGOS - Comment scanner un document
                        </span>
                    </a>
                    </div>
                    </>
                )}

                <div className="info-wrapper">
                  <span
                    style={{
                      fontSize: "12.0pt",
                      //fontFamily: "Tahoma, sans-serif",
                      color: "rgb(0, 0, 0)",
                      fontWeight: "bold",
                    }}
                  >
                    Comment m'y prendre
                  </span>
                </div>

                <div
                  style={{
                    marginBottom: "25.0pt",
                  }}>

                  1. J'ai complété et envoyé mon dossier annuel C.G.O.S pour l'année concernée,
                  <br/>2. Je choisis de faire une ou deux commandes par an (selon les règles définies par le C.G.O.S de ma
                  région),
                  <br/>3. Je choisis le format pour mes titres culture,
                  <br/>4. J'envoie ma demande,
                  <br/>5. Après la validation de ma demande par le C.G.O.S, je paye le montant de ma participation avec une carte bancaire.                
                </div>
                

                <div className="cld-dem">
                  <br></br>
                  <h1
                    style={{
                      color: "#676767",
                      fontWeight: "bold",
                      fontSize: "15.0pt",
                      fontFamily: "Tahoma, sans-serif",
                      textAlign: "center",
                    }}
                  >
                    CETTE DEMARCHE PREND 2 MINUTES
                  </h1>
                  <br></br>
                  <div className="next-button-wrapper">
                    { displayError.length > 0
                                    ? <button type="button" className="disabled" style={{ pointerEvents: "none" }}> ENVOYER UNE DEMANDE EN LIGNE </button>
                                    : <button type="button" className="btn_submit_modal" onClick={nextStep}> ENVOYER UNE DEMANDE EN LIGNE </button>}
                  </div>
                  <br></br>
                </div>

        </>
    )
}